import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import { useState } from 'react';

import { cn } from '@/utils/utils';
import { Icon } from '@/components/ui/Icon';

type CheckboxProps = {
  isError?: boolean;
  ariaLabel?: string;
  ariaLabelHidden?: boolean;
  onClick: () => void;
  label?: React.ReactNode;
  defaultChecked?: boolean;
  disabled?: boolean;
};

function Checkbox({
  isError = false,
  ariaLabel,
  ariaLabelHidden = true,
  onClick = (): void => void 0,
  label,
  defaultChecked = false,
  disabled = false
}: CheckboxProps) {
  const [checked, setChecked] = useState(defaultChecked);

  const handleCheckedChange = () => {
    setChecked((prev) => !prev);
    onClick();
  };

  return (
    <div className="inline-flex">
      <CheckboxPrimitive.Root
        className={cn("self-center",
          'w-12 h-12 shrink-0 border rounded-[30%] cursor-pointer transition-all',
          'focus:outline-0 focus-visible:ring-2 focus-visible:ring-[var(--outline-others-focus)] focus-visible:ring-offset-0',
          'bg-[var(--surface-default)]',
          'border-[var(--outline-default)]',
          'hover:bg-[var(--surface-hover)]',
          'data-[state=checked]:bg-[var(--surface-primary-fixed-default)]',
          'data-[state=checked]:border-[var(--surface-primary-fixed-default)]',
          'data-[state=checked]:hover:bg-[var(--surface-primary-fixed-hover)]',
          'data-[state=checked]:hover:border-[var(--surface-primary-fixed-hover)]',
          isError && 'border-[2px] border-[var(--redCredentials)]',
        )}
        checked={checked}
        disabled={disabled}
        onCheckedChange={handleCheckedChange}
        aria-label={ariaLabel}
      >
        <CheckboxPrimitive.Indicator className="flex items-center justify-center">
          <Icon name="StreamlineEssentialCheck1Bold" size="xs" className="text-white" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label
        aria-hidden={ariaLabelHidden}
        className="ml-6 text-[var(--on-surface-default)]"
      >
        {label}
      </label>
    </div>
  );
}

export default Checkbox;